var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('big-title',[_vm._v(" Contacto"),_c('span',[_vm._v(".")])]),_c('forms-container',{attrs:{"investor_id":_vm.InvestorId,"investor_status":_vm.InvestorStatus,"user_id":_vm.UserId,"moral-tabs":_vm.moralTabs,"pfae-tabs":_vm.pfaeTabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }